import useAPI from '@/hooks/useAPI';
import MedicationRepository, { MedicationParams } from '@/repositories/MedicationRepository';

export const useMedications = ({ person_id, show_inactive }: MedicationParams) => {
  const medicationRepository = MedicationRepository();

  const params: MedicationParams = {
    person_id,
    show_inactive: show_inactive ?? 'false'
  };

  return useAPI({
    queryKey: ['medicationsList', person_id, show_inactive],
    queryFn: async () => {
      return await medicationRepository.list(params);
    }
  });
};

export default useMedications;
